import React from 'react';

const ArabicDateTime = ({ 
  date = new Date(), 
  format = 'full',
  className = '' 
}) => {
  const formatDate = (dateObj) => {
    const day = String(dateObj?.getDate())?.padStart(2, '0');
    const month = String(dateObj?.getMonth() + 1)?.padStart(2, '0');
    const year = dateObj?.getFullYear();
    const hours = String(dateObj?.getHours())?.padStart(2, '0');
    const minutes = String(dateObj?.getMinutes())?.padStart(2, '0');

    const arabicNumerals = (num) => {
      const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
      return String(num)?.split('')?.map(digit => arabicDigits?.[parseInt(digit)])?.join('');
    };

    const dateString = `${arabicNumerals(day)}/${arabicNumerals(month)}/${arabicNumerals(year)}`;
    const timeString = `${arabicNumerals(hours)}:${arabicNumerals(minutes)}`;

    if (format === 'date') return dateString;
    if (format === 'time') return timeString;
    return `${dateString} ${timeString}`;
  };

  return (
    <span className={`font-data ${className}`} dir="ltr">
      {formatDate(date)}
    </span>
  );
};

export default ArabicDateTime;